import { X } from "lucide-react";
import { useState } from "react";

interface TagInputProps {
  value: string[];
  onChange: (tags: string[]) => void;
  placeholder?: string;
  validate?: (tag: string) => boolean; // default: always true
}

export default function TagInput({
  value,
  onChange,
  placeholder,
  validate = () => true,
}: TagInputProps) {
  const [input, setInput] = useState("");

  const addTag = (tag: string) => {
    const trimmed = tag.trim();
    if (!trimmed) return;
    if (!validate(trimmed)) return;
    if (value.includes(trimmed)) return;
    onChange([...value, trimmed]);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      addTag(input);
      setInput("");
    }
  };

  const removeTag = (idx: number) => {
    const next = value.filter((_, i) => i !== idx);
    onChange(next);
  };

  return (
    <div className="flex flex-wrap items-center gap-2 rounded-md border border-gray-300 p-2 focus-within:border-primary focus-within:ring-1 focus-within:ring-primary">
      {value.map((tag, idx) => (
        <span
          key={idx}
          className="badge badge-outline gap-1 py-2 pl-2 pr-1 text-sm"
        >
          {tag}
          <button
            type="button"
            onClick={() => removeTag(idx)}
            className="ml-1 rounded-full p-0.5 hover:bg-gray-200"
          >
            <X size={12} />
          </button>
        </span>
      ))}

      <input
        className="flex-1 min-w-[120px] border-none bg-transparent p-1 outline-hidden placeholder:text-gray-400"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
      />
    </div>
  );
}
